import * as z from "zod/v4";

export const verifyOrCreateNotOnSaleCollection = {
  name: "verifyOrCreateNotOnSaleCollection" as const,
  input: z.null(),
  output: z.string(),
};
